var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loader-fade"}},[_c('div',{staticClass:"g-loader",style:(_vm.gStyles)},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.progressColor,"size":"60","width":"5"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }